import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { usePeriodChartsDataContext } from './hooks/usePeriodChartsDataContext';

export const OcurrencesByHour = () => {
    const { chartData } = usePeriodChartsDataContext();

    return (
        <SimpleBars
            title={'Ocorrências por período (Horas do dia)'}
            horizontal={false}
            subtitles={chartData?.ocurrencesByHour?.map((item) => item.description)}
            values={chartData?.ocurrencesByHour?.map((item) => item.total || 0)}
        />
    );
};